(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[942],{

/***/ 5942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ Hiring; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 172 modules
var motion = __webpack_require__(6276);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(1893);
// EXTERNAL MODULE: ./src/utils/Animations.ts
var Animations = __webpack_require__(6638);
// EXTERNAL MODULE: ./src/utils/Container.tsx
var Container = __webpack_require__(5084);
// EXTERNAL MODULE: ./src/utils/useMediaQuery.tsx
var useMediaQuery = __webpack_require__(8308);
// EXTERNAL MODULE: ./src/components/common/button/index.tsx + 1 modules
var common_button = __webpack_require__(1733);
// EXTERNAL MODULE: ./src/components/common/svg/common/LeftArrow.tsx
var LeftArrow = __webpack_require__(2093);
// EXTERNAL MODULE: ./src/components/common/svg/common/RightArrow.tsx
var RightArrow = __webpack_require__(459);
// EXTERNAL MODULE: ./src/components/common/ui/SizedBox.tsx
var SizedBox = __webpack_require__(1680);
// EXTERNAL MODULE: ./src/components/common/ui/TiltedBar.tsx
var TiltedBar = __webpack_require__(1186);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 39 modules
var esm = __webpack_require__(9746);
;// CONCATENATED MODULE: ./src/components/common/svg/common/BriefCase.tsx

const BriefCase = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "24",
            height: "25",
            viewBox: "0 0 24 25",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M19.0005 7.76514H5.00049C3.89592 7.76514 3.00049 8.66057 3.00049 9.76514V17.7651C3.00049 18.8697 3.89592 19.7651 5.00049 19.7651H19.0005C20.1051 19.7651 21.0005 18.8697 21.0005 17.7651V9.76514C21.0005 8.66057 20.1051 7.76514 19.0005 7.76514Z",
                    stroke: "#A9B6BD",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M10.0005 12.7651L10.2115 12.8711C10.7669 13.1489 11.3795 13.2935 12.0005 13.2935C12.6215 13.2935 13.234 13.1489 13.7895 12.8711L14.0005 12.7651M9.00049 6.76514C9.00049 6.2347 9.2112 5.726 9.58628 5.35092C9.96135 4.97585 10.4701 4.76514 11.0005 4.76514H13.0005C13.5309 4.76514 14.0396 4.97585 14.4147 5.35092C14.7898 5.726 15.0005 6.2347 15.0005 6.76514V7.76514H9.00049V6.76514Z",
                    stroke: "#A9B6BD",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};
/* harmony default export */ var common_BriefCase = (BriefCase);

;// CONCATENATED MODULE: ./src/components/common/svg/common/Clock.tsx

const Clock = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "24",
            height: "25",
            viewBox: "0 0 24 25",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12.0005 22.7651C17.5233 22.7651 22.0005 18.288 22.0005 12.7651C22.0005 7.24229 17.5233 2.76514 12.0005 2.76514C6.47764 2.76514 2.00049 7.24229 2.00049 12.7651C2.00049 18.288 6.47764 22.7651 12.0005 22.7651Z",
                    stroke: "#A9B6BD",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M15.0005 16.7651L12.5865 14.3511C12.2114 13.9762 12.0006 13.4675 12.0005 12.9371V6.76514",
                    stroke: "#A9B6BD",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};
/* harmony default export */ var common_Clock = (Clock);

;// CONCATENATED MODULE: ./src/components/common/svg/common/Globe.tsx

const Globe = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "24",
            height: "25",
            viewBox: "0 0 24 25",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12.0005 21.7651C16.9711 21.7651 21.0005 17.7357 21.0005 12.7651C21.0005 7.79457 16.9711 3.76514 12.0005 3.76514C7.02993 3.76514 3.00049 7.79457 3.00049 12.7651C3.00049 17.7357 7.02993 21.7651 12.0005 21.7651Z",
                    stroke: "#A9B6BD",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M8.00049 4.76514V6.76514C8.00049 7.29557 8.2112 7.80428 8.58628 8.17935C8.96135 8.55442 9.47006 8.76514 10.0005 8.76514H11.0005C11.5309 8.76514 12.0396 8.97585 12.4147 9.35092C12.7898 9.726 13.0005 10.2347 13.0005 10.7651C13.0005 11.2956 13.2112 11.8043 13.5863 12.1793C13.9613 12.5544 14.4701 12.7651 15.0005 12.7651C15.5309 12.7651 16.0396 12.5544 16.4147 12.1793C16.7898 11.8043 17.0005 11.2956 17.0005 10.7651C17.0005 10.2347 17.2112 9.726 17.5863 9.35092C17.9613 8.97585 18.4701 8.76514 19.0005 8.76514H20.0005M20.0005 16.7651H17.0005C16.4701 16.7651 15.9613 16.9759 15.5863 17.3509C15.2112 17.726 15.0005 18.2347 15.0005 18.7651V20.7651M11.0005 20.7651V18.7651C11.0005 18.2347 10.7898 17.726 10.4147 17.3509C10.0396 16.9759 9.53092 16.7651 9.00049 16.7651C8.47006 16.7651 7.96135 16.5544 7.58627 16.1793C7.2112 15.8043 7.00049 15.2956 7.00049 14.7651C7.00049 14.2347 6.78977 13.726 6.4147 13.3509C6.03963 12.9759 5.53092 12.7651 5.00049 12.7651H3.00049",
                    stroke: "#A9B6BD",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};
/* harmony default export */ var common_Globe = (Globe);

;// CONCATENATED MODULE: ./src/components/common/svg/common/Signal.tsx

const Signal = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "24",
            height: "25",
            viewBox: "0 0 24 25",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.5005 4.76514C19.3305 4.76514 20.0005 5.43514 20.0005 6.26514V19.2651C20.0005 20.0951 19.3305 20.7651 18.5005 20.7651C17.6705 20.7651 17.0005 20.0951 17.0005 19.2651V6.26514C17.0005 5.43514 17.6705 4.76514 18.5005 4.76514ZM6.50049 14.7651C7.33049 14.7651 8.00049 15.4351 8.00049 16.2651V19.2651C8.00049 20.0951 7.33049 20.7651 6.50049 20.7651C5.67049 20.7651 5.00049 20.0951 5.00049 19.2651V16.2651C5.00049 15.4351 5.67049 14.7651 6.50049 14.7651ZM12.5005 9.76514C13.3305 9.76514 14.0005 10.4351 14.0005 11.2651V19.2651C14.0005 20.0951 13.3305 20.7651 12.5005 20.7651C11.6705 20.7651 11.0005 20.0951 11.0005 19.2651V11.2651C11.0005 10.4351 11.6705 9.76514 12.5005 9.76514Z",
                fill: "#A9B6BD"
            })
        })
    });
};
/* harmony default export */ var common_Signal = (Signal);

;// CONCATENATED MODULE: ./src/components/landing/hiring/HiringCard.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n  gap: 15px;\n  min-height: 160px;\n  ",
        "\n\n  border-radius: ",
        ";\n  background: #fff;\n  ",
        ' {\n    padding: 30px 40px;\n    gap: 30px;\n    min-width: 350px;\n  }\n  transition: all 0.3s ease;\n\n  :hover {\n    & > div > button {\n      display: flex;\n    }\n    background: linear-gradient(\n      var(--gradient-angle),\n      hsla(0, 0%, 100%, 0.5),\n      hsla(0, 0%, 100%, 0.1),\n      #fff,\n      hsla(0, 0%, 100%, 0.3)\n    );\n    animation: gradient-rotate 5s linear 0s infinite reverse;\n    @property --gradient-angle {\n      syntax: "<angle>";\n      inherits: false;\n      initial-value: 1turn;\n    }\n    @keyframes gradient-rotate {\n      0% {\n        --gradient-angle: 360deg;\n      }\n      100% {\n        --gradient-angle: 0deg;\n      }\n    }\n  }\n'
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        '\n  margin: 0px;\n  font-family: "LEMON MILK";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 27px;\n  color: #14171d;\n  ',
        " {\n    line-height: 32px;\n    background: ",
        ";\n    -webkit-background-clip: ",
        ";\n    -webkit-text-fill-color: ",
        ";\n    background-clip: text;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  column-gap: 12px;\n  row-gap: 5px;\n  flex-wrap: wrap;\n  /* min-width: 230px; */\n  ",
        " {\n    max-width: auto;\n    gap: 11px;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 5px;\n  width: fit-content;\n  ",
        ' {\n    flex-direction: row;\n  }\n  span {\n    font-family: "Lato";\n    font-style: normal;\n    font-weight: 300;\n    font-size: 12px;\n    line-height: 14px;\n    color: #14171d;\n\n    ',
        " {\n      font-size: 16px;\n      line-height: 19px;\n    }\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}











const HiringCardWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* A7AColumn */.V2).withConfig({
    componentId: "sc-341173bd-0"
})(_templateObject(), Container/* SquircleOutlined2 */.Bh, (props)=>props.theme.borderRadius, (props)=>props.theme.mediaQuery.tablet);
const HiringCardTitle = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-341173bd-1"
})(_templateObject1(), (props)=>props.theme.mediaQuery.tablet, (props)=>props.isActive ? props.theme.colors.accent : "inital", (props)=>props.isActive ? "text" : "inital", (props)=>props.isActive ? "transparent" : "inital");
const HiringCardDetailsWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* A7ARow */.ml).withConfig({
    componentId: "sc-341173bd-2"
})(_templateObject2(), (props)=>props.theme.mediaQuery.tablet);
const HiringCardDetailsContainer = (0,styled_components_browser_esm/* default */.ZP)(Container/* A7ACenteredRow */.as).withConfig({
    componentId: "sc-341173bd-3"
})(_templateObject3(), (props)=>props.theme.mediaQuery.tablet, (props)=>props.theme.mediaQuery.tablet);
const HiringCard = (param)=>{
    let { id , title , time , location , jobType , isActive , jobDesignation , onClick  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)("landing");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HiringCardWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HiringCardTitle, {
                    isActive: isActive,
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(HiringCardDetailsWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HiringCardDetailsContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Clock, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: time
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HiringCardDetailsContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Globe, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: location
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HiringCardDetailsContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_BriefCase, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: jobType
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HiringCardDetailsContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Signal, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: jobDesignation
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_button/* GenericButton */.M, {
                    text: t("hiring.2.applyForPost"),
                    height: 50,
                    width: 0,
                    isFullWidth: true,
                    isDisabled: false,
                    isProcessing: false,
                    onClick: onClick,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SizedBox/* default */.Z, {
                            width: 18,
                            height: 0
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RightArrow/* default */.Z, {})
                    ]
                })
            ]
        }, id)
    });
};
/* harmony default export */ var hiring_HiringCard = (HiringCard);

// EXTERNAL MODULE: ./node_modules/react-whirlpool/dist/esm/index.js + 1 modules
var dist_esm = __webpack_require__(4990);
// EXTERNAL MODULE: ./node_modules/react-whirlpool/dist/cjs/component/SimpleCarousel.css
var SimpleCarousel = __webpack_require__(9541);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(2175);
// EXTERNAL MODULE: ./src/components/common/Input/index.tsx + 5 modules
var Input = __webpack_require__(4133);
;// CONCATENATED MODULE: ./src/components/common/svg/common/Calender.tsx

const Calender = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: 19,
        height: 19,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.346 16.435H4.25a1.5 1.5 0 0 1-1.5-1.5v-9a1.5 1.5 0 0 1 1.5-1.5h9a1.5 1.5 0 0 1 1.5 1.5v3",
                stroke: "#A9B6BD",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14 17.185a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
                stroke: "#A9B6BD",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.75 2.935v3m-6-3v3m-3 3h12M14 13.057v1.128l.75.75",
                stroke: "#A9B6BD",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
/* harmony default export */ var common_Calender = (Calender);

;// CONCATENATED MODULE: ./src/components/common/svg/common/CrossIcon.tsx

const CrossIcon = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: 24,
        height: 26,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        style: {
            cursor: "pointer"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "m13.41 13 4.3-4.323a1.016 1.016 0 0 0 0-1.43 1 1 0 0 0-1.42 0L12 11.579 7.71 7.247a1 1 0 0 0-1.42 0 1.016 1.016 0 0 0 0 1.43L10.59 13l-4.3 4.322a1.007 1.007 0 0 0-.219 1.103c.05.123.125.234.219.328a1.001 1.001 0 0 0 .71.298.994.994 0 0 0 .71-.298L12 14.42l4.29 4.333a1.001 1.001 0 0 0 .71.298.994.994 0 0 0 .71-.298 1.006 1.006 0 0 0 .296-.715 1.013 1.013 0 0 0-.296-.716L13.41 13Z",
            fill: "#EB5647"
        })
    });
/* harmony default export */ var common_CrossIcon = (CrossIcon);

// EXTERNAL MODULE: ./src/components/common/svg/common/Email.tsx
var Email = __webpack_require__(9967);
;// CONCATENATED MODULE: ./src/components/common/svg/common/HeartBreak.tsx

const HeartBreak = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: 19,
        height: 19,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "m2.75 2.935 13.5 13.5m-1.125-6.32L14 11.184m-1.5 1.5-3 3-5.625-5.57m0 0a3.75 3.75 0 0 1-.966-3.802 3.732 3.732 0 0 1 1.34-1.878m2.25-.75a3.739 3.739 0 0 1 3 1.505 3.75 3.75 0 1 1 5.626 4.929",
            stroke: "#A9B6BD",
            strokeWidth: 1.5,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
/* harmony default export */ var common_HeartBreak = (HeartBreak);

;// CONCATENATED MODULE: ./src/components/common/svg/common/Person.tsx

const Person = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: 19,
        height: 19,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M9.5 8.935a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM5 16.435v-1.5a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v1.5",
            stroke: "#A9B6BD",
            strokeWidth: 1.5,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
/* harmony default export */ var common_Person = (Person);

;// CONCATENATED MODULE: ./src/components/common/svg/common/StackOverflow.tsx

const StackOverflow = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: 19,
        height: 19,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.5 13.435v.75a1.5 1.5 0 0 0 1.5 1.5h9a1.5 1.5 0 0 0 1.5-1.5v-.75m-9-.75h6m-5.758-2.563 5.967.627M7.09 7.56l5.87 1.248m-4.888-3.8 5.706 1.853",
            stroke: "#A9B6BD",
            strokeWidth: 1.5,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
/* harmony default export */ var common_StackOverflow = (StackOverflow);

;// CONCATENATED MODULE: ./src/components/common/svg/common/Telephone.tsx

const Telephone = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: 19,
        height: 19,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M4.25 3.685h3l1.5 3.75L6.875 8.56a8.25 8.25 0 0 0 3.75 3.75l1.125-1.875 3.75 1.5v3a1.5 1.5 0 0 1-1.5 1.5A12 12 0 0 1 2.75 5.185a1.5 1.5 0 0 1 1.5-1.5",
            stroke: "#A9B6BD",
            strokeWidth: 1.5,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
/* harmony default export */ var common_Telephone = (Telephone);

;// CONCATENATED MODULE: ./src/components/landing/hiring/HiringModal.tsx

function HiringModal_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 100vh;\n  overflow-y: scroll;\n\n  @media (max-height: 810px) {\n    padding-top: 150px;\n  }\n\n  @media (max-height: 700px) {\n    padding-top: 300px;\n  }\n\n  @media (max-height: 600px) {\n    padding-top: 400px;\n  }\n"
    ]);
    HiringModal_templateObject = function() {
        return data;
    };
    return data;
}
function HiringModal_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 95vw;\n  margin: 0 auto;\n  border-radius: 12px;\n  z-index: 4;\n  background-color: ",
        ";\n  padding: 20px;\n  overflow-y: auto;\n  ",
        " {\n    max-width: 577px;\n    padding: 40px;\n  }\n"
    ]);
    HiringModal_templateObject1 = function() {
        return data;
    };
    return data;
}
function HiringModal_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n"
    ]);
    HiringModal_templateObject2 = function() {
        return data;
    };
    return data;
}
function HiringModal_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0px;\n  font-weight: 500;\n  color: ",
        ";\n  font-size: 24px;\n  line-height: 32px;\n  ",
        " {\n    font-size: 36px;\n    line-height: 49px;\n  }\n"
    ]);
    HiringModal_templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0px;\n  font-size: 20px;\n  line-height: 27px;\n  font-weight: 500;\n  color: ",
        ";\n  ",
        " {\n    font-size: 24px;\n    line-height: 32px;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-wrap: wrap;\n  gap: 10px;\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 5px;\n  color: ",
        ";\n  span {\n    margin-top: 2px;\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  padding: 0px;\n  border-radius: 50%;\n  ",
        " {\n    width: 50px;\n    height: 50px;\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Lato';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 20px;\n  user-select: none;\n  /* identical to box height, or 143% */\n\n  letter-spacing: 0.03em;\n\n  /* Gradient */\n\n  background: linear-gradient(90deg, #26a7cf 0%, #27af8f 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 15px;\n  width: 100%;\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}





















const HiringModalWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* A7ACenteredRow */.as).withConfig({
    componentId: "sc-3f27cbad-0"
})(HiringModal_templateObject());
const HiringModalContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3f27cbad-1"
})(HiringModal_templateObject1(), (props)=>props.theme.colors.background, (props)=>props.theme.mediaQuery.tablet);
const HiringModalHeaderContainer = (0,styled_components_browser_esm/* default */.ZP)(Container/* A7AXSpaceBetweenRow */.sY).withConfig({
    componentId: "sc-3f27cbad-2"
})(HiringModal_templateObject2());
const HiringModalTitle = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-3f27cbad-3"
})(HiringModal_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.colors.textColors[0];
}, (props)=>props.theme.mediaQuery.tablet);
const HiringTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-3f27cbad-4"
})(_templateObject4(), (param)=>{
    let { theme  } = param;
    return theme.colors.textColors[0];
}, (props)=>props.theme.mediaQuery.tablet);
const HiringIconStatsContainer = (0,styled_components_browser_esm/* default */.ZP)(Container/* A7AYCenteredRow */.$J).withConfig({
    componentId: "sc-3f27cbad-5"
})(_templateObject5());
const HiringIconTextContainer = (0,styled_components_browser_esm/* default */.ZP)(Container/* A7ARow */.ml).withConfig({
    componentId: "sc-3f27cbad-6"
})(_templateObject6(), (param)=>{
    let { theme  } = param;
    return theme.colors.textColors[0];
});
const CrossIconContainer = (0,styled_components_browser_esm/* default */.ZP)(Container/* A7ACenteredRow */.as).withConfig({
    componentId: "sc-3f27cbad-7"
})(_templateObject7(), (props)=>props.theme.mediaQuery.tablet, (props)=>props.theme.colors.borderColor2);
const RightText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-3f27cbad-8"
})(_templateObject8());
const JobForm = (0,styled_components_browser_esm/* default */.ZP)(Container/* A7AXCenteredColumn */.fL).withConfig({
    componentId: "sc-3f27cbad-9"
})(_templateObject9());
const HiringModal = (param)=>{
    let { isOpened , closeModal , data  } = param;
    const isMobile = (0,useMediaQuery/* useMediaQuery */.a)("(max-width: 500px)");
    const formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            name: "",
            intro: "",
            email: "",
            phone: "",
            techStack: "",
            hateStack: "",
            avaliability: "",
            timeZone: ""
        },
        onSubmit: (values)=>{
            alert(JSON.stringify(values, null, 2));
        }
    });
    const validate = ()=>{
        if (!formik.values.name || !formik.values.intro || !formik.values.phone || !formik.values.techStack || !formik.values.hateStack || !formik.values.avaliability || !formik.values.timeZone || !formik.values.email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) return false;
        else return true;
    };
    (0,react.useEffect)(()=>{
        if (isOpened) {
            document.body.style.overflowY = "hidden";
        } else {
            document.body.style.overflowY = "auto";
        }
    }, [
        isOpened
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HiringModalWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HiringModalContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HiringModalHeaderContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* A7ACenteredRow */.as, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TiltedBar/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SizedBox/* default */.Z, {
                                        height: 0,
                                        width: 20
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HiringModalTitle, {
                                        children: "Apply job"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CrossIconContainer, {
                                onClick: closeModal,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_CrossIcon, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SizedBox/* default */.Z, {
                        height: isMobile ? 28 : 32,
                        width: 0
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HiringTitle, {
                        children: data.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SizedBox/* default */.Z, {
                        height: isMobile ? 10 : 15,
                        width: 0
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HiringIconStatsContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HiringIconTextContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Globe, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: data.location
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HiringIconTextContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_BriefCase, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: data.jobType
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HiringIconTextContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Signal, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: data.jobDesignation
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SizedBox/* default */.Z, {
                        height: 30,
                        width: 0
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(JobForm, {
                        as: "form",
                        onSubmit: formik.handleSubmit,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* A7AInputField */.Fn, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Person, {}),
                                placeholder: "Name",
                                id: "name",
                                inputMode: "text",
                                type: "text",
                                onChange: formik.handleChange,
                                value: formik.values.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* A7ATextArea */.Zp, {
                                placeholder: "Tell us more about you",
                                id: "intro",
                                type: "text",
                                inputMode: "text",
                                onChange: formik.handleChange,
                                value: formik.values.intro
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* A7AInputField */.Fn, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Email/* default */.Z, {}),
                                placeholder: "Your email address",
                                id: "email",
                                type: "email",
                                inputMode: "email",
                                onChange: formik.handleChange,
                                value: formik.values.email
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* A7AInputField */.Fn, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Telephone, {}),
                                placeholder: "Phone number",
                                id: "phone",
                                inputMode: "tel",
                                type: "number",
                                onChange: formik.handleChange,
                                value: formik.values.phone
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* A7ATagsInput */.d5, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_StackOverflow, {}),
                                placeholder: "Technical stack",
                                id: "techStack",
                                inputMode: "text",
                                type: "text",
                                onChange: formik.handleChange,
                                value: formik.values.techStack
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* A7ATagsInput */.d5, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_HeartBreak, {}),
                                placeholder: "Technologies you don’t like",
                                id: "hateStack",
                                type: "text",
                                inputMode: "text",
                                onChange: formik.handleChange,
                                value: formik.values.hateStack
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* A7AInputField */.Fn, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_BriefCase, {
                                    style: {
                                        paddingRight: 5
                                    }
                                }),
                                placeholder: "Number of available hours per week",
                                id: "avaliability",
                                inputMode: "numeric",
                                onChange: formik.handleChange,
                                value: formik.values.avaliability,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RightText, {
                                    children: "HOURS/WEEK"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* A7ASelectionInput */.qE, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Calender, {}),
                                placeholder: "Time Zone",
                                id: "timeZone",
                                inputMode: "numeric",
                                type: "text",
                                option: [
                                    "Volvo",
                                    "Saab",
                                    "Mercedes",
                                    "Audi"
                                ],
                                onChange: formik.handleChange,
                                value: formik.values.timeZone
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SizedBox/* default */.Z, {
                                height: isMobile ? 20 : 30,
                                width: 0
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* A7ACenteredRow */.as, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_button/* GenericButton */.M, {
                                    text: "SUBMIT MESSAGE",
                                    height: 50,
                                    type: "submit",
                                    width: 221,
                                    isFullWidth: false,
                                    isDisabled: !validate(),
                                    isProcessing: false,
                                    onClick: ()=>{},
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SizedBox/* default */.Z, {
                                            width: 18,
                                            height: 0
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RightArrow/* default */.Z, {
                                            color: validate() ? "white" : "#848DA0"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-portal/es/PortalCompat.js + 3 modules
var PortalCompat = __webpack_require__(779);
;// CONCATENATED MODULE: ./src/components/common/modal/A7AModalWrapper.tsx

function A7AModalWrapper_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 4;\n  background-color: #000000b0;\n  backdrop-filter: blur(10px);\n  height: 100%;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  display: ",
        ";\n"
    ]);
    A7AModalWrapper_templateObject = function() {
        return data;
    };
    return data;
}
function A7AModalWrapper_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transform: translateY(-100%);\n  opacity: 0;\n  transition: all 0.3s ease-in-out;\n  max-width: 99%;\n  height: 100%;\n  width: 100%;\n  @media only screen and (max-width: 576px) {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  & > div {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    @media only screen and (max-width: 576px) {\n      position: relative;\n      top: inherit;\n      left: inherit;\n      display: flex;\n      justify-content: center;\n    }\n  }\n"
    ]);
    A7AModalWrapper_templateObject1 = function() {
        return data;
    };
    return data;
}





const A7AModalWrapperWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-314e4eaa-0"
})(A7AModalWrapper_templateObject(), (props)=>props.isOpen ? "flex" : "none");
const A7AModalWrapperAnimater = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-314e4eaa-1"
})(A7AModalWrapper_templateObject1());
const A7AModalWrapper = /*#__PURE__*/ react.forwardRef((param, ref)=>{
    let { Modal , isOpen , onClose  } = param;
    const [hasWindow, setHasWindow] = (0,react.useState)(false);
    const wrapperRef = (0,react.useRef)();
    const animaterRef = (0,react.useRef)();
    const [isOpenState, setIsOpenState] = (0,react.useState)(isOpen);
    (0,react.useEffect)(()=>{
        setHasWindow(true);
    }, []);
    const sleep = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
    (0,react.useEffect)(()=>{
        (async ()=>{
            if (hasWindow) {
                if (isOpen) {
                    setIsOpenState(true);
                    await sleep(100);
                    animaterRef.current.style.opacity = 1;
                    animaterRef.current.style.transform = "translateY(0)";
                    document.body.style.overflow = "hidden";
                } else {
                    animaterRef.current.style.transform = "translateY(-100%)";
                    animaterRef.current.style.opacity = 0;
                    await sleep(200);
                    setIsOpenState(false);
                    document.body.style.overflow = "auto";
                }
            } else {}
        })();
    // }
    }, [
        isOpen,
        hasWindow
    ]);
    return !hasWindow ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PortalCompat/* default */.Z, {
        node: document && document.getElementById("myportal"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(A7AModalWrapperWrapper, {
            ref: wrapperRef,
            onClick: onClose,
            isOpen: isOpenState,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(A7AModalWrapperAnimater, {
                onClick: ()=>{
                    onClose();
                },
                ref: animaterRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    onClick: (e)=>{
                        e.stopPropagation();
                    },
                    children: isOpenState && Modal
                })
            })
        })
    });
});
A7AModalWrapper.displayName = "A7AModalWrapper";
/* harmony default export */ var modal_A7AModalWrapper = (A7AModalWrapper);

;// CONCATENATED MODULE: ./src/components/landing/hiring/index.tsx

function hiring_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 50px;\n  background-image: url('/images/HiringBackground.webp');\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  justify-content: flex-start;\n"
    ]);
    hiring_templateObject = function() {
        return data;
    };
    return data;
}
function hiring_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: ",
        ";\n  max-width: ",
        ";\n"
    ]);
    hiring_templateObject1 = function() {
        return data;
    };
    return data;
}
function hiring_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    hiring_templateObject2 = function() {
        return data;
    };
    return data;
}
function hiring_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0px;\n  font-weight: 500;\n  color: #14171d;\n  font-size: 24px;\n  line-height: 32px;\n  ",
        " {\n    font-size: 36px;\n    line-height: 49px;\n  }\n"
    ]);
    hiring_templateObject3 = function() {
        return data;
    };
    return data;
}
function hiring_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Lato';\n  width: 100%;\n  font-style: normal;\n  margin: 0px;\n  margin-top: 34px;\n  font-weight: 300;\n  font-size: 14px;\n\n  line-height: 17px;\n  ",
        " {\n    margin-top: 30.5px;\n    font-size: 16px;\n    max-width: ",
        ";\n    line-height: 19px;\n  }\n  color: ",
        ";\n"
    ]);
    hiring_templateObject4 = function() {
        return data;
    };
    return data;
}
function hiring_templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        ";\n  margin-top: 30px;\n  justify-content: flex-start;\n  gap: 20px;\n  ",
        " {\n    max-width: calc(100% - 60px);\n    margin-top: 60px;\n    flex-direction: row;\n  }\n  ",
        " {\n    max-width: 1200px;\n  }\n"
    ]);
    hiring_templateObject5 = function() {
        return data;
    };
    return data;
}


















const HiringWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* A7ACenteredColumn */.N$).attrs({
    as: "section"
}).withConfig({
    componentId: "sc-222ef0f2-0"
})(hiring_templateObject());
const HiringHeaderWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* A7AYCenteredColumn */.A9).withConfig({
    componentId: "sc-222ef0f2-1"
})(hiring_templateObject1(), (props)=>props.theme.constrainedMargin, (props)=>props.theme.desktopWidth);
const HiringHeaderContainer = (0,styled_components_browser_esm/* default */.ZP)(Container/* A7AXSpaceBetweenRow */.sY).withConfig({
    componentId: "sc-222ef0f2-2"
})(hiring_templateObject2());
const HiringHeading = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-222ef0f2-3"
})(hiring_templateObject3(), (props)=>props.theme.mediaQuery.tablet);
const HiringDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-222ef0f2-4"
})(hiring_templateObject4(), (props)=>props.theme.mediaQuery.tablet, (props)=>props.theme.desktopWidth, (props)=>props.theme.colors.textColors[1]);
const hiring_HiringCardWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* A7AColumn */.V2).withConfig({
    componentId: "sc-222ef0f2-5"
})(hiring_templateObject5(), (props)=>props.theme.constrainedMargin, (props)=>props.theme.mediaQuery.tablet, (props)=>props.theme.mediaQuery.desktop);
const Hiring = ()=>{
    const isMobile = (0,useMediaQuery/* useMediaQuery */.a)("(max-width: 767px)");
    const { t  } = (0,esm/* useTranslation */.$G)("landing");
    const [activeIndex, setActiveIndex] = (0,react.useState)(0);
    const simpleCarouselRef = (0,react.useRef)();
    const [hiringModalState, setHiringModal] = (0,react.useState)(false);
    const [activeModalIndex, setActiveModalIndex] = (0,react.useState)(0);
    const hiringData = [
        {
            id: 0,
            title: "IOS DEVELOPER",
            time: "12 Oct 2022",
            location: "Worldwide",
            jobType: "Remote , Full time",
            jobDesignation: "Mid level"
        },
        {
            id: 1,
            title: "ANDROID DEVELOPER",
            time: "9 Oct 2022",
            location: "Worldwide",
            jobType: "Remote , Full time",
            jobDesignation: "Senior level"
        },
        {
            id: 2,
            title: "UI/UX DESIGNER",
            time: "6 Oct 2022",
            location: "Worldwide",
            jobType: "Remote , Full time",
            jobDesignation: "Mid level"
        },
        {
            id: 3,
            title: "UI/UX DESIGNER",
            time: "6 Oct 2022",
            location: "Worldwide",
            jobType: "Remote , Full time",
            jobDesignation: "Mid level"
        }
    ];
    (0,react.useEffect)(()=>{
        console.log("false");
    }, [
        hiringModalState
    ]);
    if (true) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_A7AModalWrapper, {
                isOpen: hiringModalState,
                onClose: ()=>{
                    setHiringModal(false);
                },
                Modal: /*#__PURE__*/ (0,jsx_runtime.jsx)(HiringModal, {
                    data: hiringData[activeModalIndex],
                    isOpened: hiringModalState,
                    closeModal: ()=>setHiringModal(!hiringModalState)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HiringWrapper, {
                id: "career",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HiringHeaderWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HiringHeaderContainer, {
                                as: motion/* motion.div */.E.div,
                                variants: Animations/* variantContainer */.N,
                                initial: "hidden",
                                whileInView: "show",
                                viewport: {
                                    once: true
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* A7ACenteredRow */.as, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TiltedBar/* default */.Z, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SizedBox/* default */.Z, {
                                                height: 0,
                                                width: 20
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HiringHeading, {
                                                as: motion/* motion.h1 */.E.h1,
                                                variants: Animations/* variantitem */.f,
                                                children: t("hiring.0.hiringTitle")
                                            })
                                        ]
                                    }),
                                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* A7ACenteredRow */.as, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_button/* SocialButton */.Z, {
                                                    ariaLabel: "left arrow",
                                                    onClick: ()=>{
                                                        simpleCarouselRef.current && simpleCarouselRef.current.handlePrevEvent();
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftArrow/* default */.Z, {})
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SizedBox/* default */.Z, {
                                                    height: 0,
                                                    width: 9
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_button/* SocialButton */.Z, {
                                                    ariaLabel: "right arrow",
                                                    onClick: ()=>{
                                                        simpleCarouselRef.current && simpleCarouselRef.current.handleNextEvent();
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RightArrow/* default */.Z, {})
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HiringDescription, {
                                as: motion/* motion.p */.E.p,
                                variants: Animations/* variantitem */.f,
                                children: t("hiring.1.hiringDescription")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(hiring_HiringCardWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_esm/* SimpleCarousel */.P, {
                            isHorizontal: isMobile ? false : true,
                            gap: 20,
                            autoPlay: false,
                            minHeight: "154px",
                            ref: simpleCarouselRef,
                            hideInitGap: false,
                            hideArrows: true,
                            onActiveIndexUpdate: (index)=>setActiveIndex(index),
                            children: hiringData.map((job)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(hiring_HiringCard, {
                                    jobDesignation: job.jobDesignation,
                                    jobType: job.jobType,
                                    location: job.location,
                                    isActive: job.id === activeIndex,
                                    time: job.time,
                                    title: job.title,
                                    id: job.id.toString(),
                                    onClick: ()=>{
                                        {
                                            setActiveModalIndex(job.id);
                                            setHiringModal(!hiringModalState);
                                        }
                                    }
                                }, job.id))
                        })
                    }),
                    isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SizedBox/* default */.Z, {
                                height: 30,
                                width: 0
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_button/* GenericButton */.M, {
                                text: "View more",
                                height: 45,
                                width: 180,
                                isFullWidth: false,
                                isDisabled: false,
                                isProcessing: false,
                                onClick: ()=>{},
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SizedBox/* default */.Z, {
                                        width: 18,
                                        height: 0
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RightArrow/* default */.Z, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SizedBox/* default */.Z, {
                        width: 0,
                        height: isMobile ? 30 : 60
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 9541:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 4990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* reexport */ component_SimpleCarousel; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/react-whirlpool/dist/esm/component/SimpleCarousel.js

var SimpleCarousel = (0,react.forwardRef)(function (_a, ref) {
    var children = _a.children, isHorizontal = _a.isHorizontal, gap = _a.gap, minHeight = _a.minHeight, minWidth = _a.minWidth, onActiveIndexUpdate = _a.onActiveIndexUpdate, _b = _a.autoPlay, autoPlay = _b === void 0 ? false : _b, _c = _a.hideArrows, hideArrows = _c === void 0 ? true : _c, _d = _a.hideDevPanel, hideDevPanel = _d === void 0 ? true : _d, _e = _a.hideInitGap, hideInitGap = _e === void 0 ? true : _e;
    var _f = (0,react.useState)(0), selectedIndex = _f[0], setSelectedIndex = _f[1];
    var _g = (0,react.useState)(isHorizontal), isHorizontalState = _g[0], setIsHorizontal = _g[1];
    var containerRef = (0,react.useRef)();
    var itemRef = (0,react.useRef)();
    var _h = (0,react.useState)(0), left = _h[0], setLeft = _h[1];
    var _j = (0,react.useState)(0), n = _j[0], setN = _j[1]; //no of cards displayed in one time
    // const [gapState, setGap] = useState(gap);
    var _k = (0,react.useState)(0), dim = _k[0], setDim = _k[1];
    var _l = (0,react.useState)(null), touchPosition = _l[0], setTouchPosition = _l[1];
    (0,react.useImperativeHandle)(ref, function () { return ({
        handleNextEvent: function () {
            setSelectedIndex(function (s) { return s + 1; });
        },
        handlePrevEvent: function () {
            setSelectedIndex(function (s) { return s - 1; });
        }
    }); });
    // const [windowWidth, setWindowWidth] = useState(0);
    // const [windowHeight, setWindowHeight] = useState(0);
    var resizeWindow = function () {
        // setWindowWidth(window.innerWidth);
        // setWindowHeight(window.innerHeight);
        recalculate();
    };
    (0,react.useEffect)(function () {
        resizeWindow();
        window.addEventListener('resize', resizeWindow);
        return function () { return window.removeEventListener('resize', resizeWindow); };
    }, []);
    (0,react.useEffect)(function () {
        var interval;
        if (autoPlay) {
            interval = setInterval(function () {
                setSelectedIndex(function (s) { return s + 1; });
            }, 3000);
        }
        else {
            clearInterval(interval);
        }
        return function () {
            clearInterval(interval);
        };
    }, [autoPlay]);
    (0,react.useEffect)(function () {
        setIsHorizontal(isHorizontal);
    }, [isHorizontal]);
    (0,react.useEffect)(function () {
        var x = (100 * gap) / dim;
        if (selectedIndex >= children.length - n && selectedIndex < children.length) {
            setLeft((children.length - n) * (100 + x));
        }
        else if (selectedIndex === children.length) {
            setSelectedIndex(0);
        }
        else if (selectedIndex === -1) {
            setSelectedIndex(children.length - 1);
        }
        else {
            setLeft(selectedIndex * (100 + x));
        }
        onActiveIndexUpdate && onActiveIndexUpdate(selectedIndex);
    }, [selectedIndex, n]);
    (0,react.useEffect)(function () {
        if (containerRef.current) {
            if (isHorizontal) {
                var width = containerRef.current.offsetWidth;
                setN(Math.floor(width / (dim + gap)));
            }
            else {
                var height = containerRef.current.offsetHeight;
                setN(Math.floor(height / (dim + gap)));
            }
        }
    }, [dim]);
    var recalculate = function () {
        if (itemRef.current) {
            if (isHorizontal) {
                var itemWidth = itemRef.current.offsetWidth;
                setDim(itemWidth);
            }
            else {
                var itemHeight = itemRef.current.offsetHeight;
                setDim(itemHeight);
            }
        }
    };
    var handleNext = function () {
        setSelectedIndex(function (s) { return s + 1; });
    };
    var handlePrev = function () {
        setSelectedIndex(function (s) { return s - 1; });
    };
    var handleRadioChange = function (event) {
        if (event.target.value === 'vertical') {
            setIsHorizontal(false);
        }
        else {
            setIsHorizontal(true);
        }
    };
    var handleTouchStart = function (e) {
        var touchDown = e.touches[0].clientX;
        setTouchPosition(touchDown);
        console.log('touchstart');
    };
    var handleTouchMove = function (e) {
        var touchDown = touchPosition;
        console.log('touchDown');
        if (touchDown === null) {
            return;
        }
        var currentTouch = e.touches[0].clientX;
        var diff = touchDown - currentTouch;
        if (diff > 2) {
            handleNext();
        }
        if (diff < -2) {
            handlePrev();
        }
        setTouchPosition(null);
    };
    SimpleCarousel.displayName = 'SimpleCarousel';
    return (react.createElement(react.Fragment, null,
        react.createElement("div", { style: {
                height: '100%',
                width: '100%'
            } },
            isHorizontalState && (react.createElement("div", { className: 'carousel-container-x', ref: containerRef, style: { minHeight: minHeight, gap: gap } },
                !hideInitGap && react.createElement("div", { style: { width: gap } }),
                children.map(function (Item, key) { return (react.createElement("div", { onTouchStart: handleTouchStart, onTouchMove: handleTouchMove, style: {
                        transform: "translate(-".concat(left, "%)"),
                        // border: selectedIndex === key ? "2px solid black" : "none",
                        borderRadius: 10
                    }, ref: itemRef, key: key }, Item)); }))),
            !isHorizontalState && (react.createElement("div", { className: 'carousel-container-y', ref: containerRef, style: { minWidth: minWidth, gap: gap } },
                !hideInitGap && react.createElement("div", { style: { height: gap } }),
                children.map(function (Item, key) { return (react.createElement("div", { style: {
                        transform: "translateY(-".concat(left, "%)")
                    }, ref: itemRef, key: key }, Item)); })))),
        react.createElement("div", { className: 'carousel-options' },
            !hideArrows && (react.createElement("div", null,
                react.createElement("button", { className: 'previous-button', onClick: handlePrev }, "Previous"),
                react.createElement("button", { className: 'next-button', onClick: handleNext }, "Next"))),
            !hideDevPanel && (react.createElement("div", null,
                "Orientation:",
                react.createElement("div", { onChange: handleRadioChange },
                    react.createElement("input", { type: 'radio', name: 'orientation', value: 'horizontal', defaultChecked: true }),
                    "horizontal",
                    react.createElement("input", { type: 'radio', name: 'orientation', value: 'vertical' }),
                    "vertical"))))));
});
/* harmony default export */ var component_SimpleCarousel = (SimpleCarousel);
//# sourceMappingURL=SimpleCarousel.js.map
;// CONCATENATED MODULE: ./node_modules/react-whirlpool/dist/esm/index.js


//# sourceMappingURL=index.js.map

/***/ })

}]);